// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"fef0d484","834":"fbf95d99"}[chunkId] + ".chunk.js";
};